(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(8037);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4890);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2980);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: calc( 42px + ( 4 * var( --stack-basis ) ) ) auto 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function AppChrome(param) {
    var _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _footerPageSegments = param.footerPageSegments, footerPageSegments = _footerPageSegments === void 0 ? null : _footerPageSegments, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                navigationBar: navigationBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAppMain, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                pageSegments: footerPageSegments
            })
        ]
    });
}
var StyledAppMain = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc7e6c0-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (AppChrome);


/***/ }),

/***/ 2980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _lib_craft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8767);
/* harmony import */ var _pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1135);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Footer(param) {
    var _pageSegments = param.pageSegments, pageSegments = _pageSegments === void 0 ? null : _pageSegments;
    var ref, ref1, ref2;
    var craftData = (0,_lib_craft__WEBPACK_IMPORTED_MODULE_2__/* .useCraft */ .Yi)();
    var segments = pageSegments || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.pageSegments);
    if (!segments) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            pageSegments: segments
        })
    });
}
var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e2154cb-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 4890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./lib/craft/index.tsx + 31 modules
var craft = __webpack_require__(8767);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/BrixelLogo.tsx
var BrixelLogo = __webpack_require__(2290);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/navigationBar/NavigationBar.tsx + 6 modules
var NavigationBar = __webpack_require__(8549);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
;// CONCATENATED MODULE: ./components/icons/TelephoneIcon.tsx

function TelephoneIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.34452 7.54331C6.47782 7.41006 6.58356 7.25186 6.65571 7.07775C6.72785 6.90363 6.76498 6.717 6.76498 6.52853C6.76498 6.34006 6.72785 6.15343 6.65571 5.97931C6.58356 5.80519 6.47782 5.64699 6.34452 5.51375L4.82218 3.99212C4.55311 3.72313 4.18822 3.57202 3.80776 3.57202C3.42729 3.57202 3.06241 3.72313 2.79334 3.99212L1.95827 4.82719C1.60831 5.17815 1.39021 5.63915 1.3408 6.13231C1.29139 6.62547 1.41371 7.12057 1.68709 7.53398C4.1442 11.2325 7.31495 14.4032 11.0134 16.8603C11.4269 17.1336 11.9221 17.2558 12.4152 17.2063C12.9084 17.1567 13.3694 16.9385 13.7202 16.5884L14.556 15.7534C14.825 15.4843 14.9761 15.1194 14.9761 14.7389C14.9761 14.3585 14.825 13.9936 14.556 13.7245L13.0337 12.2029C12.7646 11.9339 12.3997 11.7828 12.0193 11.7828C11.6388 11.7828 11.2739 11.9339 11.0048 12.2029L10.4976 12.7101C8.79588 11.3104 7.23415 9.74868 5.83444 8.04693L6.34452 7.54331Z",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 0.718506C11.7672 0.718506 13.8657 1.58772 15.4129 3.13494C16.9601 4.68216 17.8293 6.78064 17.8293 8.96874",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 3.58813C11.0061 3.58813 12.3747 4.15502 13.3838 5.16407C14.3928 6.17313 14.9597 7.5417 14.9597 8.96872",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 6.45776C10.245 6.45776 10.8837 6.72231 11.3546 7.1932C11.8255 7.66409 12.09 8.30276 12.09 8.96871",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/OpenClosed.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  > span {\n    @media ( max-width: 600px ) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: inherit;\n  color: inherit;\n  text-decoration-color: transparent;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n  transition: text-decoration-color .3s ease-out;\n  &:hover {\n    text-decoration-color: inherit;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 20rem;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







function OpenClosed() {
    var ref, ref1;
    var ref2 = (0,router.useRouter)(), locale = ref2.locale, defaultLocale = ref2.defaultLocale;
    var craftData = (0,craft/* useCraft */.Yi)();
    var ref3 = (0,react.useState)(null), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(null), nextOpen = ref4[0], setNextOpen = ref4[1];
    var serializedOpeningTimes = JSON.stringify(craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes);
    var openingTimes = (0,react.useMemo)(function() {
        var ref, ref1;
        return (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes) || [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        serializedOpeningTimes
    ]);
    var weekdayFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        weekday: "long"
    });
    var timeFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        timeStyle: "short"
    });
    (0,react.useEffect)(function() {
        var timer = null;
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(function() {
            // check if open
            setIsOpen(areWeOpen(openingTimes));
            setNextOpen(whenAreWeNextOpen(openingTimes));
        }, 1000 * 60);
        setIsOpen(areWeOpen(openingTimes));
        setNextOpen(whenAreWeNextOpen(openingTimes));
    }, [
        openingTimes
    ]);
    if (isOpen === null) {
        return null;
    }
    if (isOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        description: "[Brixel] is open",
                        defaultMessage: "is open",
                        id: "FthgtD"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUs, {})
            ]
        });
    }
    if (nextOpen && nextOpen.getDate() !== new Date().getDate()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens on [Monday/Tuesday/etc…]",
                    defaultMessage: "opens on ",
                    id: "RlDzFA"
                }),
                " ",
                weekdayFormatter.format(nextOpen)
            ]
        });
    }
    if (nextOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens at [9am]",
                    defaultMessage: "opens at ",
                    id: "HS4fmx"
                }),
                " ",
                timeFormatter.format(nextOpen)
            ]
        });
    }
    return null;
}
function CallUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCallUs, {
        href: "tel:+41 44 552 57 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelephoneIcon, {})
            }),
            "+41 44 552 57 30"
        ]
    });
}
var StyledOpenClosed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-0"
})(_templateObject(), function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.typo.sizes.dropped;
});
var StyledCallUs = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ef933484-1"
})(_templateObject1());
var StyledPhoneIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.green100;
});
function areWeOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var today = now.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(now, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (now >= slot.opens && now <= slot.closes) {
            return true;
        }
    }
    return false;
}
function whenAreWeNextOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var nextOpenToday = whenAreWeNextOpenOnDay(now, openingTimes);
    if (nextOpenToday) {
        return nextOpenToday;
    }
    for(var i = 0, len = daysOfTheWeek.length; i < len; i += 1){
        var thisDay = new Date(now);
        thisDay.setUTCHours(0);
        thisDay.setUTCMinutes(0);
        thisDay.setUTCSeconds(0);
        thisDay.setDate(thisDay.getDate() + i);
        var nextOpenThisDay = whenAreWeNextOpenOnDay(thisDay, openingTimes);
        if (nextOpenThisDay) {
            return nextOpenThisDay;
        }
    }
    return false;
}
function whenAreWeNextOpenOnDay(day, openingTimes) {
    var today = day.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(day, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (day < slot.opens) {
            return slot.opens;
        }
    }
    return false;
}
function todaysOpeningTimesToSlots(now, openingTimes) {
    return openingTimes.reduce(function(slots, ot, currentIndex) {
        var ref;
        if (currentIndex % 2) {
            return slots;
        }
        var openingTime = new Date(ot.time);
        var closingTime = new Date(((ref = openingTimes[currentIndex + 1]) === null || ref === void 0 ? void 0 : ref.time) || null);
        openingTime.setFullYear(now.getFullYear());
        openingTime.setMonth(now.getMonth());
        openingTime.setDate(now.getDate());
        closingTime.setFullYear(now.getFullYear());
        closingTime.setMonth(now.getMonth());
        closingTime.setDate(now.getDate());
        return (0,_to_consumable_array/* default */.Z)(slots).concat([
            {
                opens: openingTime,
                closes: closingTime
            }, 
        ]);
    }, []);
}
var daysOfTheWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday", 
];

;// CONCATENATED MODULE: ./components/Header.tsx

function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: ",
        ";\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-right: 1rem;\n  }\n\n  > * + *:last-child {\n    margin-left: auto;\n    margin-right: 0;\n  }\n\n  svg {\n    display: block;\n  }\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function Header(param) {
    var _logoLink = param.logoLink, logoLink = _logoLink === void 0 ? "/" : _logoLink, _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _openClosed = param.openClosed, openClosed = _openClosed === void 0 ? null : _openClosed, _children = param.children, children = _children === void 0 ? null : _children;
    var ref, ref1, ref2, ref3, ref4;
    var craftData = (0,craft/* useCraft */.Yi)();
    var navBar = navigationBar || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.header) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.navigationBar);
    var showOpenClosed = openClosed === null ? craftData === null || craftData === void 0 ? void 0 : (ref3 = craftData.pageProps) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.businessHours) === null || ref4 === void 0 ? void 0 : ref4.openSign : openClosed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            $containerType: "small-margin",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                $top: 2,
                $bottom: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderInner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: logoLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrixelLogo/* default */.Z, {
                                breakpoint: 500
                            })
                        }),
                        showOpenClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenClosed, {}),
                        !!(navBar === null || navBar === void 0 ? void 0 : navBar.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* default */.Z, {
                            navigationBar: navBar
                        }),
                        children
                    ]
                })
            })
        })
    });
}
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-0"
})(Header_templateObject(), function(p) {
    return p.theme.colors.realWhite;
});
var StyledHeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-1"
})(Header_templateObject1());
/* harmony default export */ var components_Header = (Header);


/***/ }),

/***/ 8923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function EmailIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "97",
        height: "97",
        viewBox: "0 0 97 97",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.377 20.3643C15.8135 20.3457 15.3416 20.7875 15.323 21.351L15.2436 23.7515L82.1008 29.9661C82.6622 30.0183 83.075 30.5158 83.0229 31.0772L79.1072 73.2018L84.8544 73.3917C85.4179 73.4103 85.8898 72.9686 85.9084 72.405L87.5165 23.7363C87.5351 23.1728 87.0934 22.7008 86.5298 22.6822L16.377 20.3643Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.1953",
                y: "23.3751",
                width: "72.233",
                height: "50.7372",
                rx: "1.40625",
                transform: "rotate(5.31064 11.1953 23.3751)",
                stroke: "#06262D",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.9541 24.2555C11.6787 23.9359 11.9325 23.4437 12.3526 23.4827L81.961 29.9531C82.381 29.9921 82.5397 30.5228 82.2101 30.7861L46.0534 59.6693C44.8718 60.6133 43.1551 60.4537 42.1677 59.3081L11.9541 24.2555Z",
                stroke: "#06262D",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.80475 73.4475L34.4768 50.4823",
                stroke: "#06262D",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M78.121 80.0769L55.1559 52.4047",
                stroke: "#06262D",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.80475 73.4475L34.4768 50.4823",
                stroke: "#06262D",
                strokeWidth: "1.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M78.121 80.0769L55.1559 52.4047",
                stroke: "#06262D",
                strokeWidth: "1.25"
            })
        ]
    });
}


/***/ }),

/***/ 4278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PhoneIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function PhoneIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "97",
        height: "97",
        viewBox: "0 0 97 97",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.6206 52.4064L21.8289 43.9135L21.8351 43.9324C17.9028 38.1721 15.5786 31.4695 15.1012 24.5094L14.1356 10.5L13.0019 11.6337C10.8064 13.8292 9.15068 16.4978 8.16815 19.4453L7.50708 21.4104C5.83924 26.3957 6.19707 31.8299 8.49567 36.5545L12.2802 44.3115L20.0372 56.417C25.3137 64.5622 32.2519 71.5005 40.3971 76.7769L52.5026 84.5339L60.2597 88.3185C64.9842 90.6231 70.4244 90.9749 75.4037 89.307L77.3688 88.646C80.3102 87.6634 82.9849 86.0077 85.1804 83.8122L87.8853 81.1073C89.5835 79.4091 90.5296 77.0923 90.4993 74.6845C90.4591 71.5946 88.8331 68.8001 86.2832 67.2149C86.1271 67.1493 85.9686 67.0876 85.8078 67.0301C85.5063 66.9233 85.1733 66.9987 84.9472 67.2249L77.0386 75.1335C72.7796 79.3925 66.3032 80.5169 60.8507 77.9477L53.4446 74.4488C43.0232 69.5302 34.1095 61.9231 27.6206 52.4064Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.5 20.3433C55.6674 20.3433 62.8348 23.0763 68.3009 28.5424C73.767 34.0084 76.5 41.1758 76.5 48.3433",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M88.5 48.3433C88.5 38.1065 84.5971 27.8697 76.7853 20.0579C68.9735 12.2461 58.7368 8.34326 48.5 8.34326",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M76.5 48.3433C76.5 41.1758 73.767 34.0084 68.3009 28.5424C62.8348 23.0763 55.6674 20.3433 48.5 20.3433",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M48.5 32.3433C52.5965 32.3433 56.6931 33.9059 59.8122 37.031C62.9314 40.1562 64.5 44.2528 64.5 48.3433",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M64.5 48.3433C64.5 44.2467 62.9374 40.1502 59.8122 37.031C56.687 33.9119 52.5905 32.3433 48.5 32.3433",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20.0614 56.4279C25.336 64.5701 32.2719 71.5058 40.4143 76.7804L52.5157 84.5345L60.27 88.3177C64.993 90.6215 70.4313 90.9731 75.4089 89.3059L77.3733 88.645C80.3137 87.6629 82.9875 86.0078 85.1822 83.8131L87.8862 81.1091C89.5838 79.4116 90.5296 77.0956 90.4993 74.6887C90.4508 70.9602 88.0924 67.6621 84.588 66.401L70.4253 61.3326C68.0365 60.4778 65.3689 61.1568 63.6773 63.0423L60.9369 66.104C59.1363 68.1168 56.117 68.4745 53.8919 66.9345L41.5541 58.4104C40.9417 57.986 40.3718 57.5131 39.8504 56.9917C39.329 56.4703 38.8501 55.8944 38.4317 55.2881L29.9074 42.9505C28.3735 40.7255 28.7251 37.7063 30.738 35.9057L33.7997 33.1653C35.6913 31.4738 36.3643 28.8063 35.5095 26.4176L30.4409 12.2551C29.1859 8.7448 25.8817 6.38641 22.153 6.34397C19.7461 6.31366 17.4362 7.25338 15.7325 8.957L13.0285 11.661C10.8337 13.8557 9.17859 16.5232 8.19641 19.4697L7.53557 21.434C5.86829 26.4176 6.226 31.8497 8.52381 36.5726L12.307 44.3268L20.0614 56.4279V56.4279Z",
                stroke: "#06262D",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}


/***/ }),

/***/ 8037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Custom404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/AppChrome.tsx
var AppChrome = __webpack_require__(1904);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/contact/ContactCard.tsx
var ContactCard = __webpack_require__(4921);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/promotionOnboarding/icons/PhoneIcon.tsx
var PhoneIcon = __webpack_require__(4278);
// EXTERNAL MODULE: ./components/promotionOnboarding/icons/EmailIcon.tsx
var EmailIcon = __webpack_require__(8923);
;// CONCATENATED MODULE: ./components/contact/ContactErrorFooter.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: calc( 8 * var( --stack-basis ) ) 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n\n  > * {\n    &:first-child {\n      flex: 0 0 50%;\n      max-width: 25rem;\n      margin-right: auto;\n\n      h2 {\n        margin: 0 0 1rem 0;\n        font-size: ",
        ";\n      }\n    }\n  }\n\n  @media (min-width: 1050px) {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: calc( 2 * var( --grid-gutter ) );\n\n  > * {\n    max-width: 305px;\n    /* min-width: min( 250px, 100% ); */\n    flex: 0 0 25%;\n  }\n\n  @media (min-width: 500px) {\n    flex-direction: row;\n  }\n  \n  @media (min-width: 1050px) {\n    justify-content: space-evenly;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function ContactErrorFooter() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContactErrorFooterBorder, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContactErrorFooter, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Get in touch",
                                    id: "BTZrof",
                                    description: "Contact title: Get in touch"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "If you need help selling or buying, or would like to report a problem, please contact Brixel.",
                                    id: "gus/j8",
                                    description: "Error contact subtitle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContactCards, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactErrorFooter_ContactCard, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Call us",
                                    id: "mWoieu",
                                    description: "Contact card title: Call us"
                                }),
                                linkText: "+41 44 552 57 30",
                                linkHref: "tel:+41445525730",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneIcon/* PhoneIcon */.q, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactErrorFooter_ContactCard, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Email us",
                                    id: "QhhPzk",
                                    description: "Contact card title: Email us"
                                }),
                                linkText: "hallo@brixel.ch",
                                linkHref: "mailto:hallo@brixel.ch",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailIcon/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function ContactErrorFooter_ContactCard(param) {
    var title = param.title, linkText = param.linkText, linkHref = param.linkHref, icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactCard/* StyledContactCard */.$, {
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                style: {
                    wordBreak: "normal",
                    whiteSpace: "nowrap"
                },
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: linkHref,
                        children: linkText
                    })
                ]
            })
        ]
    });
}
var StyledContactErrorFooterBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcd0f4d-0"
})(_templateObject(), function(p) {
    return p.theme.colors.grey200;
});
var StyledContactErrorFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcd0f4d-1"
})(_templateObject1(), function(p) {
    return p.theme.typo.sizes.large;
});
var StyledContactCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcd0f4d-2"
})(_templateObject2());

// EXTERNAL MODULE: ./components/heroes/HeroIllustration.tsx
var HeroIllustration = __webpack_require__(9379);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
;// CONCATENATED MODULE: ./components/ErrorPage.tsx






function ErrorPage(param) {
    var title = param.title, subtitle = param.subtitle, illustrationUrl = param.illustrationUrl, containerCSS = param.containerCSS, buttonLabel = param.buttonLabel, buttonLink = param.buttonLink, buttonColor = param.buttonColor, buttonIcon = param.buttonIcon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppChrome/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
            $between: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroIllustration/* default */.Z, {
                    title: title,
                    subtitle: subtitle,
                    image: {
                        url: illustrationUrl,
                        alt: title
                    },
                    imagePosition: "center",
                    bgColor: "realWhite",
                    objectPosition: "center",
                    objectFit: "contain",
                    containerCSS: containerCSS,
                    buttonLabel: buttonLabel,
                    buttonLink: buttonLink,
                    buttonColor: buttonColor,
                    buttonIcon: buttonIcon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactErrorFooter, {})
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/404.tsx



var __N_SSG = true;
function Custom404() {
    var illustrationContainerCSS = "\n    min-height: 65vh;\n    \n    > div:first-child {\n      width: 100%;\n      max-width: 500px;\n      margin: 0 auto;\n    }\n  ";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            defaultMessage: "Page not found",
            id: "HfEl6c",
            description: "404 page title"
        }),
        subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            defaultMessage: "We couldn't find the page you were looking for.",
            id: "WrCo4m",
            description: "404 page subtitle"
        }),
        illustrationUrl: "/images/404.svg",
        containerCSS: illustrationContainerCSS,
        buttonLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            defaultMessage: "Go to the homepage",
            id: "4tUhkX",
            description: "404 page button label"
        }),
        buttonLink: "/",
        buttonColor: "green",
        buttonIcon: "home"
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,756,274,783,135,379,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);